import React from 'react';
// import Auth from '../../../config/auth';


import { 
    Result,
    Button,
} from 'antd';


export default function NotFoundScreen(props) {
	const onclick=()=>{
            props.history.push({
                pathname: `/`,
                state: 'MI DATA de Login'
            })
    }
	return (
        <div>
            <Result
                status="404"
                title="404"
                subTitle="Ops!, la página que solicitas no existe o su sesión a expirado."
                extra={<Button type="primary" onClick={()=>onclick()}>Iniciar sesión</Button>}
            />
        </div>
    )
}